import React, { FC } from "react";
import GallerySlider from "components/GallerySlider/GallerySlider";
import { DEMO_STAY_LISTINGS } from "data/listings";
import { StayDataType } from "data/types";
import StartRating from "components/StartRating/StartRating";
import { Link } from "react-router-dom";
import BtnLikeIcon from "components/BtnLikeIcon/BtnLikeIcon";
import SaleOffBadge from "components/SaleOffBadge/SaleOffBadge";
import PetFriendly from "components/PetFriendly/petFriendly";
import PriceBadge from "components/PriceBadge/priceBadge";
import Badge from "shared/Badge/Badge";

export interface StayCardProps {
  className?: string;
  ratioClass?: string;
  data?: StayDataType;
  size?: "default" | "small";
  targetlanguage?:string;
}

const DEMO_DATA = DEMO_STAY_LISTINGS[0];

const StayCard: FC<StayCardProps> = ({
  size = "default",
  className = "",
  data = DEMO_DATA,
  ratioClass = "aspect-w-3 aspect-h-2",
  targetlanguage  = localStorage.getItem("targetlanguage") ? localStorage.getItem("targetlanguage") : (window.location.hostname=='tinyaway.com.tw' || window.location.hostname=='www.tinyaway.com.tw')?"zh_tw":"en",
}) => {
  const {
    galleryImgs,
    listingCategory,
    address,
    title,
    bedrooms,
    beds,
    maxGuests,
    bathrooms,
    href,
    like,
    saleOff,
    pets_frendly,
    isAds,
    price,
    reviewStart,
    reviewCount,
    id,
    currency_code
  } = data;

  const renderSliderGallery = () => {
    return (
      <div className="relative w-full">
        <GallerySlider
          uniqueID={`stay-v-${id}`}
          ratioClass={ratioClass}
          galleryImgs={galleryImgs}
        />
        <BtnLikeIcon isLiked={like} className="absolute right-3 top-3" />
        {saleOff && <SaleOffBadge desc={saleOff} className="absolute left-3 top-3" />}
        {pets_frendly && <PetFriendly desc={pets_frendly} className="absolute right-3 bottom-3" />}
        {/*{pets_frendly && <PriceBadge desc={pets_frendly} className="absolute left-1 bottom-5" />}*/}
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className={size === "default" ? "p-4 space-y-4" : "p-3 space-y-2"}>
        <div className="space-y-2">
        <span className="text-sm text-neutral-500 dark:text-neutral-400">
           
           {targetlanguage=='zh_tw'?'微型屋':'Tiny House , '} {bedrooms} {targetlanguage=='zh_tw'?'臥室':'bedroom'} 
          </span>
          <div className="flex items-center space-x-2">
            {isAds && <Badge name="ADS" color="green" />}
            <h2
              className={` font-medium capitalize ${
                size === "default" ? "text-lg" : "text-base"
              }`}
            >
              <span className="line-clamp-1">{title}</span>
            </h2>
          </div>
          <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">
            {size === "default" && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            )}
            <span className="">{address}</span>
          </div>
        </div>
        <div className="w-full border-b border-neutral-100 dark:border-neutral-800"></div>
         <div className="hidden sm:grid grid-cols-3 gap-2">
         <div className="space-y-3">
            <div className="flex items-center space-x-3">
              <i className="las la-bed text-lg"></i>
              <span className="text-sm text-neutral-500 dark:text-neutral-400">
              {beds} {targetlanguage=='zh_tw'?'床':'bed'}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex items-center space-x-3">
              <i className="las la-bath text-lg"></i>
              <span className="text-sm text-neutral-500 dark:text-neutral-400">
              {bathrooms} {targetlanguage=='zh_tw'?'衛浴':'bath'}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex items-center space-x-3">
              <i className="las la-user text-lg"></i>
              <span className="text-sm text-neutral-500 dark:text-neutral-400">
                {maxGuests} {targetlanguage=='zh_tw'?'成人':'guest'}
              </span>
            </div>
          </div>
        </div> 
        <div className="flex justify-between items-center">
          <span className="text-lg font-semibold">
          <><sup>{currency_code}</sup>{price}</>
            {` `}
            {size === "default" && (
              <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                / {targetlanguage=='zh_tw'?'每晚起':'night'}
              </span>
            )}
          </span>
          {!!reviewStart && (
            <StartRating reviewCount={reviewCount} point={reviewStart} isHost={false} />
          )}
        </div>
      </div>
    );
  };

  return (
    <div
      className={`nc-StayCard group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow ${className}`}
      data-nc-id="StayCard"
    >
      <Link to={href}>
        {renderSliderGallery()}
        {renderContent()}
      </Link>
    </div>
  );
};

export default StayCard;
